import { UrlConstants } from "../url.constants";
export class ApiInformalTradeConstants {
    static URL = UrlConstants.API_V2 + "InformalTrading";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalInformalTradingApplication";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetInformalTradingApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateInformalTradingInvoiceReport";
    static FUNCTION_SET_PROPERTIES = "SetInformalTradingProperties";
    static FUNCTION_SET_TRADERS = "SetTraders";
    static FUNCTION_GET_MY_AFLA_INFORMAL_TRADING_APPLICATIONS = "GetMyAFLAPortalInformalTradingApplications";
    static FUNCTION_GET_APPLICATION_TYPE = "GetItApplicationTypes";
}
